import { isExternal } from '@shared/utils/url'
import * as S from './styles'
import React from 'react'
import { TAGThemeProvider, Typography } from '@taglivros/tag-components'

export function Link( { text, typography, path, ...props }: Link.Props ): React.ReactElement {
  const children = (
    <TAGThemeProvider>
      <Typography
        { ...typography }
      >
        { text }
      </Typography>
    </TAGThemeProvider>
  )

  if ( isExternal( path ) ) {
    return (
      <a
        { ...props }
        href={ path }
      >{children}
      </a>
    )
  } else {
    return (
      <S.Anchor
        { ...props }
        to={ path }
      >{children}
      </S.Anchor>
    )
  }
}

namespace Link {
  export interface Props {
    path: string
    text: string
    typography: Typography.Props
  }
}
